module.exports = __webpack_public_path__ + "img/energy.60c8a747.png";